import { MutationTree } from 'vuex'
import { ELibraryStateInterface } from 'src/store/eLibrary/state'
import { BucketItem } from 'minio'

const mutation: MutationTree<ELibraryStateInterface> = {

  setDirectories (state: ELibraryStateInterface, directory: Array<BucketItem>): void {
    state.directoryObjectList = directory
  },

  setFiles (state: ELibraryStateInterface, file: Array<BucketItem>): void {
    state.fileObjectList = file
  },

  setSelectedObject (state: ELibraryStateInterface, file: BucketItem): void {
    state.selectedObject.push(file)
  },

  resetSelectedObject (state: ELibraryStateInterface): void {
    state.selectedObject = []
  },

  setTotalStorageUsed (state: ELibraryStateInterface, totalStorageUsed: number): void {
    console.debug('E-Library: setTotalStorageUsed: ', totalStorageUsed)
    state.totalStorageUsed = totalStorageUsed
  }

}

export default mutation
